// extracted by mini-css-extract-plugin
export var formContainer = "_gg-0";
export var message = "_gg-1";